import { useQuery } from "@apollo/client/react";
import { GetApplicationContext } from "hooks/apollo/applicationContext/applicationContext.gql";
import { GetAssignedSites } from "hooks/apollo/site/site.gql";
import groupBy from "lodash/groupBy";
import React from "react";
import SiteSwitcherView from "./SiteSwitcherView";

function SiteSwitcherContainer(props) {
  const {
    applicationContext: { site: currentSite },
  } = useQuery(GetApplicationContext).data;
  const { data } = useQuery(GetAssignedSites);

  const assignedSites = data?.assignedSites || [];
  const companies = groupBy(assignedSites, "company.name");

  if (assignedSites.length <= 1) {
    return null;
  }

  return <SiteSwitcherView companies={companies} currentSiteId={currentSite.id} {...props} />;
}

export default SiteSwitcherContainer;
